module.exports = __webpack_public_path__ + "img/frontend_base_drones.1f220d20.jpg";